export enum InfoRoutesPathEnum {
    SUPPORT = '/support/',
    FAQS = '/faqs/',
    PRIVACY = '/privacy-policy/',
    TERMS = '/terms-of-use/',
    IMPRESSUM = '/impressum/',
    CONTACTS = '/contacts/',
}
